import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Style from '../header/__main.module.css';

/*
    - ihoDesignSystem
*/
import { Box, Grid, Image, List, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import GridType2SVG from '../../assets/images/icons/grid-type-2.svg';
import CalendarSVG from '../../assets/images/icons/calendar.svg';
import UsersSVG from '../../assets/images/icons/users.svg';
import HeartSVG from '../../assets/images/icons/heart.svg';
import WalletSVG from '../../assets/images/icons/wallet.svg';
import RequestSVG from '../../assets/images/icons/request.svg';

import GridType2SolidSVG from '../../assets/images/icons/grid-type-2-solid.svg';
import CalendarSolidSVG from '../../assets/images/icons/calendar-solid.svg';
import UsersSolidSVG from '../../assets/images/icons/users-solid.svg';
import HeartSolidSVG from '../../assets/images/icons/heart-solid.svg';
import WalletSolidSVG from '../../assets/images/icons/wallet-solid.svg';
import RequestSolidSVG from '../../assets/images/icons/request-solid.svg';

import GridType2LightSVG from '../../assets/images/icons/grid-type-2-light.svg';
import CalendarLightSVG from '../../assets/images/icons/calendar-light.svg';
import UsersLightSVG from '../../assets/images/icons/users-light.svg';
import HeartLightSVG from '../../assets/images/icons/heart-light.svg';
import WalletLightSVG from '../../assets/images/icons/wallet-light.svg';
import RequestLightSVG from '../../assets/images/icons/request-light.svg';

const Tab = ({ props }) => {

    /*
        - defaultData
    */
    const type = localStorage.getItem('type');
    const [userProfile, setUserProfile] = React.useState([]);
    const [dashboardBadges, setDashboardBadges] = React.useState([]);

    React.useEffect(() => {
        if (props.userProfile.status === 200) {
            setUserProfile(props.userProfile.data);
        }
        if (props.dashboardBadges.status === 200) {
            setDashboardBadges(props.dashboardBadges.data);
        }
    }, [props]);

    let gridTabSvg, calendarTabSvg, usersTabSvg, heartTabSvg, financeTabSvg, requestTabSvg;
    let activeBorder = [], activeTypography = [], activeCircle = [];

    let requirement = true;
    if (type === 'B2C' && (userProfile.firstName === '' || userProfile.firstName === null || userProfile.lastName === '' || userProfile.lastName === null || userProfile.mobile === '' || userProfile.mobile === null)) {
        requirement = false;
    }

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    /*
        - routeTab
    */
    gridTabSvg = GridType2SVG;
    calendarTabSvg = CalendarSVG;
    usersTabSvg = UsersSVG;
    heartTabSvg = HeartSVG;
    financeTabSvg = WalletSVG;
    requestTabSvg = RequestSVG;

    const location = useLocation();
    if (location.pathname === '/dashboard') {
        if (scale === 'xx-large' || scale === 'x-large' || scale === 'large') {
            gridTabSvg = GridType2SolidSVG;
            activeBorder = ['border-solid-bottom border-primary', '', '', '', '', ''];
            activeTypography = ['strong', 'p', 'p', 'p', 'p', 'p'];
        }
        if (scale === 'medium' || scale === 'small' || scale === 'x-small') {
            gridTabSvg = GridType2LightSVG;
            activeCircle = ['active', '', '', '', '', ''];
        }
    } else {
        gridTabSvg = GridType2SVG;
    }
    if (location.pathname === '/reserve') {
        if (scale === 'xx-large' || scale === 'x-large' || scale === 'large') {
            calendarTabSvg = CalendarSolidSVG;
            activeBorder = ['', 'border-solid-bottom border-primary', '', '', '', ''];
            activeTypography = ['p', 'strong', 'p', 'p', 'p', 'p'];
        }
        if (scale === 'medium' || scale === 'small' || scale === 'x-small') {
            calendarTabSvg = CalendarLightSVG;
            activeCircle = ['', 'active', '', '', '', ''];
        }
    } else {
        calendarTabSvg = CalendarSVG;
    }
    if (location.pathname === '/passenger' || location.pathname === '/user/member' || location.pathname === '/user/agent' || location.pathname === '/user/passenger' || location.pathname === '/user/sub-organization') {
        if (scale === 'xx-large' || scale === 'x-large' || scale === 'large') {
            usersTabSvg = UsersSolidSVG;
            activeBorder = ['', '', 'border-solid-bottom border-primary', '', '', ''];
            activeTypography = ['p', 'p', 'strong', 'p', 'p', 'p'];
        }
        if (scale === 'medium' || scale === 'small' || scale === 'x-small') {
            usersTabSvg = UsersLightSVG;
            activeCircle = ['', '', 'active', '', '', ''];
        }
    } else {
        usersTabSvg = UsersSVG;
    }
    if (location.pathname === '/favorite') {
        if (scale === 'xx-large' || scale === 'x-large' || scale === 'large') {
            heartTabSvg = HeartSolidSVG;
            activeBorder = ['', '', '', 'border-solid-bottom border-primary', ''];
            activeTypography = ['p', 'p', 'p', 'strong', 'p', 'p'];
        }
        if (scale === 'medium' || scale === 'small' || scale === 'x-small') {
            heartTabSvg = HeartLightSVG;
            activeCircle = ['', '', '', 'active', '', ''];
        }
    } else {
        heartTabSvg = HeartSVG;
    }
    if (location.pathname === '/finance/report' || location.pathname === '/finance/settlement' || location.pathname === '/finance/bank') {
        if (scale === 'xx-large' || scale === 'x-large' || scale === 'large') {
            financeTabSvg = WalletSolidSVG;
            activeBorder = ['', '', '', '', 'border-solid-bottom border-primary', ''];
            activeTypography = ['p', 'p', 'p', 'p', 'strong', 'p'];
        }
        if (scale === 'medium' || scale === 'small' || scale === 'x-small') {
            financeTabSvg = WalletLightSVG;
            activeCircle = ['', '', '', '', 'active', ''];
        }
    } else {
        financeTabSvg = WalletSVG;
    }
    if (location.pathname === '/request' || location.pathname === '/request/history') {
        if (scale === 'xx-large' || scale === 'x-large' || scale === 'large') {
            requestTabSvg = RequestSolidSVG;
            activeBorder = ['', '', '', '', '', 'border-solid-bottom border-primary'];
            activeTypography = ['p', 'p', 'p', 'p', 'p', 'strong'];
        }
        if (scale === 'medium' || scale === 'small' || scale === 'x-small') {
            requestTabSvg = RequestLightSVG;
            activeCircle = ['', '', '', '', '', 'active'];
        }
    } else {
        requestTabSvg = RequestSVG;
    }

    return (
        <React.Fragment>
            
        {
            (scale === 'medium' || scale === 'small' || scale === 'x-small') &&
                <Box
                    className={`w-100 position-fixed bottom-sm`}
                    ms={{
                        zIndex: '1'
                    }}>
                    <Grid>
                        <Grid.Wrapper
                            className={`justify-content-center`}>
                            <Grid.Item
                                size='col-12 md-8'>
                                {requirement &&
                                    <List
                                        className={`d-flex align-item-center justify-content-between px-xl bg-white border-solid border-light rounded-lg shadow-dark`}>
                                        <List.Item
                                            className={`${Style[activeCircle[0]]} py-md`}>
                                            <Link
                                                to='/dashboard'
                                                className='d-flex align-item-center'>
                                                <Image
                                                    src={gridTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${Style[activeCircle[1]]} py-md`}>
                                            <Link
                                                to='/reserve'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={calendarTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                        {type === 'B2C' &&
                                            <List.Item
                                                className={`${Style[activeCircle[2]]} py-md`}>
                                                <Link
                                                    to='/passenger'
                                                    className={`d-flex align-item-center`}>
                                                    <Image
                                                        src={usersTabSvg}
                                                        ms={{
                                                            width: '20px',
                                                            height: '20px'
                                                        }} />
                                                </Link>
                                            </List.Item>
                                        }
                                        {type === 'B2B' &&
                                            <List.Item
                                                className={`${Style[activeCircle[2]]} py-md`}>
                                                <Link
                                                    to='/user/passenger'
                                                    className={`d-flex align-item-center`}>
                                                    <Image
                                                        src={usersTabSvg}
                                                        ms={{
                                                            width: '20px',
                                                            height: '20px'
                                                        }} />
                                                </Link>
                                            </List.Item>
                                        }
                                        <List.Item
                                            className={`${Style[activeCircle[3]]} py-md`}>
                                            <Link
                                                to='/favorite'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={heartTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${Style[activeCircle[4]]} py-md`}>
                                            <Link
                                                to='/finance/report'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={financeTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${Style[activeCircle[5]]} py-md`}>
                                            <Link
                                                to='/request'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={requestTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                    </List>
                                }
                                {!requirement &&
                                    <List
                                        className={`d-flex align-item-center justify-content-between px-xl bg-white border-solid border-light rounded-lg shadow-dark`}>
                                        <List.Item
                                            className={`${Style[activeCircle[0]]} py-md`}>
                                            <Link
                                                to='/dashboard'
                                                className='d-flex align-item-center'>
                                                <Image
                                                    src={gridTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${Style[activeCircle[1]]} py-md`}>
                                            <Link
                                                to='/dashboard'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={calendarTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${Style[activeCircle[2]]} py-md`}>
                                            <Link
                                                to='/dashboard'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={usersTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${Style[activeCircle[3]]} py-md`}>
                                            <Link
                                                to='/dashboard'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={heartTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${Style[activeCircle[4]]} py-md`}>
                                            <Link
                                                to='/dashboard'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={financeTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className='py-md'>
                                            <Link
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={requestTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                    </List>
                                }
                            </Grid.Item>
                        </Grid.Wrapper>
                    </Grid>
                </Box>
            }
            {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                <React.Fragment>
                    <Box
                        className={`my-lg`} />
                    <Grid>
                        <Grid.Wrapper>
                            <Grid.Item
                                size='col-12'>
                                {requirement &&
                                    <List
                                        className={`d-flex align-item-center justify-content-between px-xxl bg-white border-solid border-light rounded-lg`}
                                        ms={{
                                            '& li':
                                            {
                                                borderWidth: '2px'
                                            }
                                        }}>
                                        <List.Item
                                            className={`${activeBorder[0]} py-xl`}>
                                            <Link
                                                to='/dashboard'
                                                className='d-flex align-item-center'>
                                                <Image
                                                    src={gridTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[0]}>
                                                    داشبورد کاربری
                                                </Typography>
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${activeBorder[1]} py-xl position-relative`}>
                                            <Link
                                                to='/reserve'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={calendarTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[1]}>
                                                    سوابق رزرو
                                                </Typography>
                                            </Link>
                                            {dashboardBadges !== 'empty' &&
                                                <Typography
                                                    className={`d-flex align-item-end justify-content-center text-md bg-gray-light rounded-circle position-absolute top-sm`}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px',
                                                        left: '-16px'
                                                    }}>
                                                    {dashboardBadges.ActiveReservesCount}
                                                </Typography>
                                            }
                                        </List.Item>
                                        {type === 'B2C' &&
                                            <List.Item
                                                className={`${activeBorder[2]} py-xl`}>
                                                <Link
                                                    to='/passenger'
                                                    className={`d-flex align-item-center`}>
                                                    <Image
                                                        src={usersTabSvg}
                                                        ms={{
                                                            width: '20px',
                                                            height: '20px'
                                                        }} />
                                                    <Box
                                                        className={`mx-xs`} />
                                                    <Typography
                                                        component={activeTypography[2]}>
                                                        مهمانان
                                                    </Typography>
                                                </Link>
                                            </List.Item>
                                        }
                                        {type === 'B2B' &&
                                            <List.Item
                                                className={`${activeBorder[2]} py-xl`}>
                                                <Link
                                                    to='/user/passenger'
                                                    className={`d-flex align-item-center`}>
                                                    <Image
                                                        src={usersTabSvg}
                                                        ms={{
                                                            width: '20px',
                                                            height: '20px'
                                                        }} />
                                                    <Box
                                                        className={`mx-xs`} />
                                                    <Typography
                                                        component={activeTypography[2]}>
                                                        اعضا و مهمانان
                                                    </Typography>
                                                </Link>
                                            </List.Item>
                                        }
                                        <List.Item
                                            className={`${activeBorder[3]} py-xl`}>
                                            <Link
                                                to='/favorite'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={heartTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[3]}>
                                                    علاقه مندی‌ها
                                                </Typography>
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${activeBorder[4]} py-xl`}>
                                            <Link
                                                to='/finance/report'
                                                className={`d-flex align-item-cente`}>
                                                <Image
                                                    src={financeTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[4]}>
                                                    امور مالی
                                                </Typography>
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${activeBorder[5]} py-xl`}>
                                            <Link
                                                to='/request'
                                                className={`d-flex align-item-center`}>
                                                <Image
                                                    src={requestTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[5]}>
                                                    مدیریت درخواست‌ها
                                                </Typography>
                                            </Link>
                                        </List.Item>
                                    </List>
                                }
                                {!requirement &&
                                    <List
                                        className={`d-flex align-item-center justify-content-between px-xxl bg-white border-solid border-light rounded-lg`}>
                                        <List.Item
                                            className={`${activeBorder[0]} py-xl`}>
                                            <Link
                                                to='/dashboard'
                                                className='d-flex align-item-center'>
                                                <Image
                                                    src={gridTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[0]}>
                                                    داشبورد کاربری
                                                </Typography>
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${activeBorder[1]} py-xl`}>
                                            <Link
                                                to='/dashboard'
                                                className={`d-flex align-item-center disabled`}>
                                                <Image
                                                    src={calendarTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[1]}>
                                                    سوابق رزرو
                                                </Typography>
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${activeBorder[2]} py-xl`}>
                                            <Link
                                                to='/dashboard'
                                                className={`d-flex align-item-center disabled`}>
                                                <Image
                                                    src={usersTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[2]}>
                                                    لیست مهمانان
                                                </Typography>
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${activeBorder[3]} py-xl`}>
                                            <Link
                                                to='/dashboard'
                                                className={`d-flex align-item-center disabled`}>
                                                <Image
                                                    src={heartTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[3]}>
                                                    علاقه مندی‌ها
                                                </Typography>
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${activeBorder[4]} py-xl`}>
                                            <Link
                                                to='/dashboard'
                                                className={`d-flex align-item-center disabled`}>
                                                <Image
                                                    src={financeTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[4]}>
                                                    امور مالی
                                                </Typography>
                                            </Link>
                                        </List.Item>
                                        <List.Item
                                            className={`${activeBorder[5]} py-xl`}>
                                            <Link
                                                to='/request'
                                                className={`d-flex align-item-center disabled`}>
                                                <Image
                                                    src={requestTabSvg}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Box
                                                    className={`mx-xs`} />
                                                <Typography
                                                    component={activeTypography[5]}>
                                                    مدیریت درخواست‌ها
                                                </Typography>
                                            </Link>
                                        </List.Item>
                                    </List>
                                }
                            </Grid.Item>
                        </Grid.Wrapper>
                    </Grid>
                </React.Fragment>
            }
            
        </React.Fragment >
    );

}

export default Tab;